<template>
    <section v-if="hasPermissions(['Assignment-Project-Template Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="`${title_page} - ${parent.name}`"/>

        <RoomTaskAdvancedSearchVue
            class="mt-5"
            ref="advanced_search"
            :checkeable="true"
            :rest_api="rest_api"
            :rest_api_pagination="rest_api_pagination"
            :table_headers="table_headers"
            :filter_options="filter_options"
            :default_filters="default_filters"
            :array_options="array_options"
            @passInitialData="fill_data($event)"
        >
        <template v-slot:overtable>
            <div class="row mb-0 assignments">
                
                <div class="col-md-12">
                    <div class="row mb-0">
                        <div class="col-md-4">
                            <div class="templates__legend d-md-flex justify-content-md-between">
                                <div class="mb-2 mb-md-0 templates_legion_item">
                                    30 Days overdue
                                </div>
                                <div class="templates_legion_item">
                                    60 Days overdue
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="assignments__statics d-flex align-items-center" style="justify-content: right; gap: 10px;">
                                <p class="assignments__statics__text">
                                    <button class="modal__buttons__item w-auto button--2 mt-0 px-2" @click="calculateMinutes()">Calc</button>
                                </p>
                                <p class="assignments__statics__text">
                                    Current minutes: <strong>{{(rooms_assigned_minutes) ? rooms_assigned_minutes : 0}}</strong>
                                </p>

                                <p class="assignments__statics__text">
                                    Proposed addittional minutes: <strong>{{proposed_minutes}}</strong>
                                </p>

                                <p class="assignments__statics__text ">
                                    New total minutes: <strong>{{total_new_minutes}}</strong>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="modal__buttons text-center text-md-right">
                        <button type="button" class="modal__buttons__item w-auto button--2" v-html="`Refresh`" style="width:300px;" @click="reloaded()"/>
                        <button v-if="hasPermissions(['Assignment-Project-Template Write'])" type="button" class="modal__buttons__item w-auto button--2" v-html="`Add Selected Duties <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" style="width:300px; margin-left:10px;" @click="add_duties()"/>
                    </div>
                </div>
            </div>
        </template>
        </RoomTaskAdvancedSearchVue>
       

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <ScheduledFormModal 
            :title="'New Scheduled Rooms'"
            :breadcrumb="breadcrumb"
            :rest_api="scheduled_rest_api"
            :notyf="notyf"
            :scheduled_rooms="rooms"
            :array_options="scheduled_array_options"
            :scheduled_current_date="scheduled_current_date"
            @RefreshHomeLocation="refresh_location($event)"
        />

        <ValidationsModal
         :breadcrumb="breadcrumb"
        :validate_data="validate_data"
        />

        <WaitingModal/>

    </section>
    <section v-else class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            you do not have permission for this section. contact your system administrator
        </h1>
    </section>
</template>

<script>

import axios            from    'axios'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import FormResources    from    './form_resource'
import WaitingModal     from    '@/components/WaitingModal'
import Methods          from    './Methods'
import Resources        from    './resources'
import DeletionModal    from    '@/components/DeletionModal'
import ScheduledFormModal from    '../ScheduledFormModal'
import ValidationsModal   from  '@/components/AssigmentsComponent/ProjectTemplate/ValidationsModal'
import RoomTaskAdvancedSearchVue from '@/components/BuildingComponent/Rooms/RoomTaskAdvancedSearch/RoomTaskAdvancedSearch.vue'

/**********styles **********************************************/
import 'vuetify/dist/vuetify.min.css'
import { Notyf }    from    'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
})
/***************************************************************/

export default {

    name: 'ProjectRoomFilter',

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        ScheduledFormModal,
        ValidationsModal,
        RoomTaskAdvancedSearchVue
    },

    mixins:[
        Methods,
    ],

    data() {
        return {
            notyf,
            axios,
            user:               this.get_user(),
            project_id:         this.$route.params.id,
            parent:             {},
            parent_id:          '',
            current_location:   `/assignment-projects-rooms/${this.$route.params.id}`,
            title_page:         'Project',
            rest_api:           `projects-rooms/${this.$route.params.id}`,
            rest_api_pagination: `projects-rooms_pagination`,
            lite_rest_api:      `projects-rooms`,
            scheduled_rest_api: `projects-schedulers`,
            table_headers:      Resources.table_headers,
            week_table_headers: Resources.week_table_headers,
            filter_options:     Resources.filter_options,
            default_filters:    Resources.default_filters,
            breadcrumb:         Resources.breadcrumb,
            select_all:         false,

            /**** Options ************************************/
            boolean_options:    Resources.boolean_options,
            excl_options:       Resources.excl_options,
            freq_options:       Resources.freq_options,
            /*************************************************/

            form_data:          FormResources.form_data,
            week_form_data:     FormResources.week_form_data,
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       null,
            single_object:      {},
            rooms:              [],
            array_options:      {},
            scheduled_array_options: {},
            date:               '',
            scheduled_current_date: '',
            validate_data: [],
            rooms_assigned_minutes: 0,
            proposed_minutes: 0,
            total_new_minutes: 0,
        }
    },

    watch: {

    },

    async mounted()
    {
        if(this.hasPermissions(['Assignment-Project-Template Read']))
        {
            await this.scheduled_api_request()
        }
        else
        {
            window.location.href = '/'
        }
    },

    methods: 
    {
        refresh_location(event)
        {
            if(event)
            {
                window.location.href = this.current_location
            }
        },

        async scheduled_api_request()
        {
            // this.loader('get')
            
            const response = await this.get(this.scheduled_rest_api)

            // this.revoke_loader('get')

            if(response.status)
            {
                this.scheduled_current_date = response.data.current_date

                this.scheduled_array_options = {
                    building_id:        response.data.buildings,
                    area_id:            [],
                    level_id:           [],
                    project_task_id:    [],
                }
            } 
            else
            {
                this.error_handling(response)
            }
        },

    },
}
</script>
